import React, {useState} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LogoUrl from './../../assets/img/logo_inverse.svg';
import SmartLink from "../../lib/includes/components/component.smartlink";

const Footer = (props) => {
    if (!props.general) {
        return null;
    }

    return <footer className="site-footer">
        <div className="site-footer-main">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <Link to="/" className="logo">
                            <img src={LogoUrl} alt={props.general.title}/>
                        </Link>

                        {props.custom.footer.social_links &&
                            <ul className="nav nav--social">
                                {props.custom.footer.social_links.map((item, i) => {
                                    return <li key={i} className="nav-item">
                                        <a href={item.url} target="_blank" className="nav-link"><i className={"fa-" + item.icon}></i></a>
                                    </li>
                                })}
                            </ul>
                        }
                    </div>

                    {props.custom.footer.link_columns && props.custom.footer.link_columns.map((column, i) => {
                        return <div key={i} className="col-lg">
                            <h3>{column.title}</h3>
                            {column.items &&
                                <ul className="nav nav--list">
                                    {column.items.map((item, i) => {
                                        return <li key={i} className="nav-item">
                                            <SmartLink url={item.link.url} className="nav-link">{item.link.title}</SmartLink>
                                        </li>
                                    })}
                                </ul>
                            }
                        </div>
                    })}
                </div>
            </div>
        </div>

        {props.custom.footer.details &&
            <div className="site-footer_details">
                <div className="container">
                    <div dangerouslySetInnerHTML={{__html: props.custom.footer.details.replaceAll(" | ","<span>|</span>")}}></div>
                </div>
            </div>
        }

    </footer>
};

export default connect(
    state => {
        return {
            general: state.generalState.general,
            custom: state.customState
        }
    }
)(Footer);
